import { APPLICATION_TYPE_OPTIONS } from "@Shared/@Utils/constants";
export default {
  computed: {
    applicationTypeOptions() {
      return APPLICATION_TYPE_OPTIONS();
    },
    lenderTypeOptions() {
      return [{
        label: this.$t("application-form.financial-institution"),
        value: "financial-institution"
      }, {
        label: this.$t("application-form.private"),
        value: "private"
      }];
    },
    submissionMethodOptions() {
      return [{
        label: this.$t("application-form.electronic"),
        value: "electronic"
      }, {
        label: this.$t("application-form.manual"),
        value: "manual"
      }];
    },
    submissionLanguageOptions() {
      return [{
        label: this.$t("application-form.english"),
        value: "english"
      }];
    }
  }
};